import './mobileActive.css';

export default function MobileActive({expenseHubActive}) {
    return (
        <div className="mobile-active-circle" style={{'--active-expense-hub': expenseHubActive}}>
            <svg width="65" height="65" viewBox="0 0 65 65">
                <circle id="Ellipse_154" data-name="Ellipse 154" cx="32.5" cy="32.5" r="32.5" fill="#88cdf6"/>
            </svg>
        </div>
    )
}